/* ME → BIO — her career and credentials, the background her Story does not
 * cover (her example, docs/voice-layers-spec.md: "I'm an ex COO — my story
 * really doesn't cover that"). Built 2026-10-13.
 *
 * NOT the LinkedIn Bio. My Positioning writes "Bio Statements" in a
 * conversation and locks them; this is the raw fact she types herself, and
 * the Accelerator reads it as fact (api/_lib/prompts.js `aboutHerBlock`).
 * Said on screen, because the same word on two things is the one part she
 * cannot deduce by looking.
 *
 * Saves as she leaves the box (rule 1); the read-out goes amber when it does
 * not land — every save until supabase/0038 is run.
 */
import { useEffect, useRef, useState } from "react";
import { BookUser } from "lucide-react";

export const BIO_MAX = 1500;

export function BioPanel({ bio: stored, onSave, isMobile }) {
  const [text, setText] = useState(stored || "");
  const [status, setStatus] = useState("idle"); // idle | saving | saved | failed
  /* Loaded after the screen mounted (a slow settings read): take it, unless
     she has already started typing. */
  const touched = useRef(false);
  const saved = useRef(stored || "");
  useEffect(() => {
    if (!touched.current) { setText(stored || ""); saved.current = stored || ""; }
  }, [stored]);

  const leave = async () => {
    const next = text.trim();
    if (next === saved.current) return;
    setStatus("saving");
    const ok = await onSave(next);
    if (ok) saved.current = next;
    setStatus(ok ? "saved" : "failed");
  };

  const over = text.length > BIO_MAX;

  return (
    <div style={{ flex: 1, minHeight: 0, overflowY: "auto", background: "var(--bg-primary)", padding: isMobile ? "16px 16px 100px" : "32px 32px 48px" }}>
      <div style={{ maxWidth: 760, margin: "0 auto", display: "flex", flexDirection: "column", gap: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <BookUser size={18} color="var(--accent)" />
          <div style={{ flex: 1 }}>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: "var(--text-primary)" }}>Bio</h2>
            <p role="status" style={{ margin: "2px 0 0", fontSize: 12.5, color: status === "failed" ? "var(--warn-text)" : "var(--text-secondary)" }}>
              {status === "failed" ? "That didn't save. Check your connection and try again."
                : status === "saving" ? "Saving…"
                : status === "saved" ? "✓ Saved"
                : "Your career and credentials — what came before this business. Brill uses it as fact."}
            </p>
          </div>
        </div>

        <div>
          <textarea id="me-bio" aria-label="Your bio" value={text}
            onChange={(e) => { touched.current = true; setText(e.target.value); }}
            onBlur={leave}
            rows={isMobile ? 10 : 8}
            placeholder="e.g. Twelve years as a COO in healthcare. ICF-certified coach since 2021. Led a 300-person team through two mergers."
            style={{
              width: "100%", boxSizing: "border-box", padding: "12px 14px", borderRadius: 10,
              border: `1px solid ${over ? "var(--warn-text)" : "var(--border)"}`,
              background: "var(--bg-surface)", color: "var(--text-primary)",
              fontSize: 15, lineHeight: 1.6, fontFamily: "inherit", resize: "vertical",
            }} />
          <div style={{ display: "flex", justifyContent: "space-between", gap: 12, marginTop: 6, fontSize: 12, color: "var(--text-muted)" }}>
            <span>Not your LinkedIn bio — My Positioning writes that, and can draw on this.</span>
            <span style={{ whiteSpace: "nowrap", color: over ? "var(--warn-text)" : "var(--text-muted)" }}>
              {text.length} / {BIO_MAX}{over ? " · Brill reads the first " + BIO_MAX : ""}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
